import { HashRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/header/Header';
import Menu from './components/menu/Menu';
import Sushi from './components/submenu/Sushi';
import Sets from './components/product/Sushi/Sets'
import Philadelphia from './components/product/Sushi/Philadelphia';
import California from './components/product/Sushi/California';
import SushiShef from './components/product/Sushi/SushiShef';
import Dragon from './components/product/Sushi/Dragon';
import MakMenu from './components/submenu/MakMenu';
import Snaks from './components/product/MakMenu/Snaks';
import Burgers from './components/product/MakMenu/Burgers';
import Hachapury from './components/product/MakMenu/Hachapury';
import SaltyPastries from './components/product/MakMenu/Salty_Pastries';
import Salad from './components/product/Salad/Salad';
import Pizzas from './components/product/Pizza/Pizzas';
import FirstCourses from './components/product/FirstCourses/FirstCourses';
import Garnir from './components/product/Garnir/Garnir';
import Footer from './components/footer/Footer';
import Sandwich from './components/product/Sandwich/Sandwich';
import Pasta from './components/product/Pasta/Pasta';
import IceDrinks from './components/product/Drinks/IceDrinks';
import Tampura from './components/product/Sushi/Tampura';
import Hot from './components/product/Sushi/Hot';
import Sweet from './components/product/Sweet/Sweet';
import KidsMenu from './components/product/KidsMenu/KidsMenu';
import Coffee from './components/product/Drinks/Coffee';
import HotDrinks from './components/product/Drinks/HotDrinks';
import Smuzi from './components/product/Drinks/Smuzi';
import Bubble from './components/product/Bubble/Bubble';

function App() {
  return (
    <div className='wrapper'>
      <Header />
      <HashRouter>
        <Routes>
          <Route path='/' element={<Menu />} />
          {/* Суши */}
          <Route path='/sushi' element={<Sushi />} />
          <Route path='/sets' element={<Sets />} />
          <Route path='/philadelphia' element={<Philadelphia />} />
          <Route path='/california' element={<California />} />
          <Route path='/sushishef' element={<SushiShef />} />
          <Route path='/dragons' element={<Dragon />} />
          <Route path='/tampura' element={<Tampura />} />
          <Route path='/hot' element={<Hot />} />
          {/* Мак меню */}
          <Route path='/makmenu' element={<MakMenu />} />
          <Route path='/snaks' element={<Snaks />} />
          <Route path='/burgers' element={<Burgers />} />
          <Route path='/saltyPastries' element={<SaltyPastries />} />
          <Route path='/hachapury' element={<Hachapury />} />
          {/* Салати */}
          <Route path='/salads' element={<Salad />} />
          {/* Піци */}
          <Route path='/pizzas' element={<Pizzas />} />
          {/* Перші страви */}
          <Route path='/first_courses' element={<FirstCourses />} />
          {/* Гарніри */}
          <Route path='/garnir' element={<Garnir />} />
          {/* Сендвічі */}
          <Route path='/sandwich' element={<Sandwich />} />
          {/* Пасти */}
          <Route path='/pasta' element={<Pasta />} />
          {/* Напої */}
          <Route path='/ice_drinks' element={<IceDrinks />} />
          <Route path='/coffee' element={<Coffee />} />
          <Route path='/hot_drinks' element={<HotDrinks />} />
          <Route path='/smuzi' element={<Smuzi />} />
          {/* Десерти */}
          <Route path='/sweet' element={<Sweet />} />
          {/* Детское меню */}
          <Route path='/kidsMenu' element={<KidsMenu />} />
          {/* Вафля */}
          <Route path='/bubble' element={<Bubble />} />
        </Routes>
      </HashRouter>
      <Footer />
    </div>
  );
}

export default App;
